import React from 'react';
import { ShieldAlert } from 'lucide-react';
import { MESSAGE_CAISSE_RESERVEE } from '../../hooks/useHabilitationCaisse';

/**
 * Bandeau affiché à la place d'une saisie d'argent, quand la personne connectée
 * n'est pas habilitée à tenir une caisse (rôle Comptable, Gestionnaire
 * pédagogique, ou dérogation). Voir hooks/useHabilitationCaisse.js.
 */
const BandeauCaisseReservee = ({ message = MESSAGE_CAISSE_RESERVEE, className = '' }) => (
  <div className={`flex items-start gap-3 rounded-lg border border-amber-200 bg-amber-50 p-4 text-sm text-amber-900 ${className}`}>
    <ShieldAlert className="mt-0.5 h-5 w-5 flex-shrink-0 text-amber-600" />
    <div>
      <p className="font-semibold">Caisse réservée aux profils comptables</p>
      <p className="mt-1 leading-relaxed">{message}</p>
    </div>
  </div>
);

export default BandeauCaisseReservee;
